<template>
  <div class="vstack gap-2">
    <div
      class="filters-block"
      v-if="!date && (total || searchTerm?.length) && pagination"
    >
      <div class="hstack gap-3">
        <slot name="before-filter" />
        <input
          class="form-control"
          placeholder="Поиск"
          v-model="searchTerm"
        />
      </div>
      <DateSelect
        v-if="date"
        :report-type="reportType"
        @create_report="handleCreateReport"
      />
    </div>
    <slot
      :sort="sortFn"
      v-if="total || isfilter"
    />
    <Pagination
      v-if="total && pagination"
      :total-item="total"
      :current-page="Number(model.page) || 1"
      :on-page="Number(model.onPage) || 20"
      @page-change="modelValueSet"
    />
  </div>

  <template v-if="!total">
    <slot
      name="empty"
      v-if="!total"
    >
      Записей не найдено
    </slot>
    <slot name="before-filter" />
  </template>
</template>
<script setup>
import { watchThrottled } from '@vueuse/core'
import { inject, onMounted, provide, shallowRef, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useListStore } from '@provise/stores/list'
import Pagination from '@provise/components/pagination/pagination.vue'
import { onBeforeRouteLeave } from 'vue-router'
import DateSelect from '@/components/dateselect.vue'

const emit = defineEmits(['create_report'])
defineProps({
  total: {
    type: Number,
    default: 0,
  },
  date: {
    type: Boolean,
    default: false,
  },
  reportType: {
    type: String,
    default: '',
  },
  pagination: {
    type: Boolean,
    default: true,
  },
})
const model = defineModel({
  type: Object,
  default: () => ({
    page: 1,
    onPage: 20,
    search: '',
    order_direction: 'ASC',
    order_field: '',
    filter: '',
    filter_id: '',
  }),
})
const searchTerm = shallowRef('')
const listStore = useListStore()
const { historyItem } = storeToRefs(listStore)
const modalstack = inject('modalstack', () => false, true)
var isfilter = false

const handleCreateReport = period => {
  emit('create_report', period)
}

onMounted(() => {
  if (historyItem.value) {
    modelValueSet(historyItem.value)
    searchTerm.value = historyItem.value.search
  } else {
    // trigger w/ default pager values
    modelValueSet({})
  }
})

if (!modalstack) {
  onBeforeRouteLeave((to, from) => {
    if (routeNamespace(from) !== routeNamespace(to)) {
      listStore.save()
    }
  })
  watch(model, v => {
    listStore.save(v)
  })
}
watchThrottled(
  searchTerm,
  (search, osearch) => {
    // workaround: check if search term not changed
    if (search === undefined && osearch === '') {
      return
    }
    modelValueSet({ page: 1, search })
  },
  { throttle: 500 }
)

const sortFn = column => {
  const m = { ...model.value }

  if (m.order_field !== column) {
    m.order_field = column
    m.order_direction = 'ASC'
  } else {
    switch (m.order_direction) {
      case 'ASC':
        m.order_direction = 'DESC'
        break
      case 'DESC':
        delete m.order_direction
        delete m.order_field
        break
      default:
        m.order_direction = 'ASC'
    }
  }
  model.value = m
}

function routeNamespace(rt) {
  const n = rt.name.split('.')
  n.pop()
  return n.join('.')
}

function modelValueSet(newob) {
  const v = { ...model.value, ...newob }
  if (v.filter) {
    const m = { ...model.value }
    if (newob.filter || newob.filter_id) {
      let currentFilters = m.filter ? String(m.filter).split('&&') : []
      let currentFilterIds = m.filter_id ? String(m.filter_id).split('&&') : []
      const filterIndex = currentFilters.indexOf(newob.filter)
      if (filterIndex !== -1) {
        if (newob.filter_id !== '') {
          currentFilterIds[filterIndex] = newob.filter_id
        } else {
          currentFilters.splice(filterIndex, 1)
          currentFilterIds.splice(filterIndex, 1)
        }
      } else {
        if (newob.filter_id !== '') {
          currentFilters.push(newob.filter)
          currentFilterIds.push(newob.filter_id)
        }
      }
      v.filter = currentFilters.join('&&')
      v.filter_id = currentFilterIds.join('&&')
    }
    isfilter = true
  }
  for (const k of ['order_direction']) {
    if (!String(v[k]).trim().length) {
      delete v[k]
    }
  }
  for (const k of ['page', 'onPage']) {
    let val = v[k]
    if (!val) {
      continue
    }
    val = Number(val)
    if (isNaN(val)) {
      continue
    }
    v[k] = val
  }
  model.value = v
}

provide('sort-fn', sortFn)
provide('list-model', model)
provide('model-valueset', modelValueSet)
</script>
